const articleDeliveryTypes = {
	METADATA: "metadata",
	ARTIFACT: "artifact",
};

export default articleDeliveryTypes;
